import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { fmt, round, Variance, Summary } from "./reconUtils";

export default function SubmitDialog({ open, onOpenChange, lines, busy, onConfirm, storeName }) {
  const reductions = lines.filter((l) => round(l.variance) < 0);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="recon-submit-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Submit count for approval</DialogTitle>
          <DialogDescription>{storeName}: once submitted the count is locked. Stock only changes after management approves it.</DialogDescription>
        </DialogHeader>
        <Summary lines={lines} />
        {reductions.length > 0 && (
          <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-[#8f3b2f]" data-testid="recon-reductions-warning">
            {reductions.length} proposed stock reduction{reductions.length === 1 ? "" : "s"}: {reductions.map((r) => `${r.name} (−${fmt(Math.abs(r.variance))})`).join(", ")}
          </div>
        )}
        <div className="border rounded-md divide-y text-sm">
          {lines.map((l) => (
            <div key={l.product_id} className="flex items-center justify-between gap-2 p-2" data-testid={`recon-submit-line-${l.sku}`}>
              <div className="min-w-0"><div className="truncate">{l.name}</div><div className="font-mono text-[11px] text-muted-foreground">{l.sku}</div></div>
              <div className="text-right font-mono text-xs shrink-0">{fmt(l.system_qty)} → {fmt(l.counted_qty)} <div><Variance value={l.variance} /></div></div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Back</Button>
          <Button className="rounded-full" disabled={busy} onClick={onConfirm} data-testid="recon-confirm-submit-btn">Submit for approval</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
